<script>
export default {
  name: "BanobagiHeader",
  props: {
    title: {
      type: String,
      default: ""
    },
    showBack: {
      type: Boolean,
      default: false
    },
    compactBack: {
      type: Boolean,
      default: false
    },
    emphasized: {
      type: Boolean,
      default: false
    },
    actions: {
      type: Array,
      default: () => []
    }
  },
  emits: ["action"],
  methods: {
    actionLabel(action) {
      const labelKeys = {
        "redeem-code": "redeem_text"
      };
      return (
        action.label ||
        this.$t(action.labelKey || labelKeys[action.key] || action.key)
      );
    },
    emitAction(action) {
      this.$emit("action", action);
    }
  }
};
</script>

<template>
  <button
    v-if="compactBack"
    type="button"
    class="banobagi-header__compact-back"
    data-test="banobagi-header-compact-back-btn"
    :aria-label="$t('back')"
    @click="emitAction({ key: 'back' })"
  >
    <font-awesome-icon :icon="['fas', 'chevron-left']" />
  </button>

  <header v-else class="banobagi-header" data-test="banobagi-header">
    <button
      v-if="showBack"
      type="button"
      class="banobagi-header__back"
      data-test="banobagi-header-back-btn"
      :aria-label="$t('back')"
      @click="emitAction({ key: 'back' })"
    >
      <font-awesome-icon :icon="['fas', 'chevron-left']" />
    </button>
    <span v-else class="banobagi-header__spacer" aria-hidden="true"></span>

    <div
      :class="[
        'banobagi-header__title',
        { 'banobagi-header__title--emphasized': emphasized }
      ]"
      data-test="banobagi-header-title"
    >
      {{ title }}
    </div>

    <div class="banobagi-header__actions">
      <button
        v-for="action in actions"
        :key="action.key"
        type="button"
        class="banobagi-header__action"
        :data-test="`banobagi-header-${action.key}-btn`"
        :aria-label="actionLabel(action)"
        @click="emitAction(action)"
      >
        <font-awesome-icon :icon="action.icon" />
      </button>
    </div>
  </header>
</template>

<style lang="scss" scoped>
.banobagi-header {
  position: sticky;
  top: 0;
  z-index: 20;
  display: grid;
  min-height: 62px;
  grid-template-columns: 40px minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  padding: calc(12px + env(safe-area-inset-top)) 16px 12px;
  border: 1px solid var(--secondary-color-light);
  border-radius: 0 0 24px 24px;
  background: var(--secondary-color);
  box-shadow: 0 10px 28px rgba(100, 75, 105, 0.12);
  backdrop-filter: blur(18px);
}

.banobagi-header__back,
.banobagi-header__action,
.banobagi-header__compact-back {
  display: inline-flex;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: var(--primary-color);
  cursor: pointer;
}

.banobagi-header__back:focus-visible,
.banobagi-header__action:focus-visible,
.banobagi-header__compact-back:focus-visible {
  outline: 2px solid var(--primary-color);
  outline-offset: 2px;
}

.banobagi-header__compact-back {
  position: fixed;
  top: calc(16px + env(safe-area-inset-top));
  left: max(16px, calc((100vw - 480px) / 2 + 16px));
  z-index: 25;
}

.banobagi-header__spacer {
  width: 40px;
}

.banobagi-header__title {
  overflow: hidden;
  color: var(--text-color);
  font-size: var(--font-title-sm);
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

// .banobagi-header__title--emphasized {
//   font-size: var(--font-heading);
// }

.banobagi-header__actions {
  display: inline-flex;
  gap: 8px;
}
</style>
